<template>
    <div id="annexData" v-loading="loading">
        <el-row>
            <el-col :span="20">
                <div class="breadcrumb">
                    <a @click="backTop()">全部资料</a>
                    <span v-for="(item, index) in fileHierarchy" :key="index" @click="returnDirectory(item.id, index)">
                        <i class="el-icon-arrow-right"></i>
                        {{ item.data }}
                    </span>
                </div>
            </el-col>
            <el-col :span="4" class="fileBtn">
                <button class="iconfont icon-xiazai1" @click="batchDownload"></button>
            </el-col>
        </el-row>

        <div class="annexList">
            <div id="Attachment" class="Annex">
                <div style="overflow:auto;">
                    <div class="AnnexInfo" id="AnnexInfoContainer" options="Setting">
                        <table>
                            <tbody>
                                <template v-if="fileData && fileData.length>0">
                                    <tr v-for="(item, index) in fileData" :key="index" @click="seeFile(item)">
                                        <th style="width: 5%;">
                                            <svg v-if="item.FileType == 1" class="iconwenjianjia1" aria-hidden="true">
                                                <use xlink:href="#iconwenjianjia1"></use>
                                            </svg>
                                            <svg v-if="item.FileType == 0" class="iconwenjian" aria-hidden="true">
                                                <use xlink:href="#iconwenjian"></use>
                                            </svg>
                                        </th>
                                        <td style="width: 30%;">
                                            <span ref="content" class="fileName" :title="item.FileName">{{ item.FileName }}</span>
                                        </td>
                                        <td style="width: 6%;">
                                            <span v-if="item.data_type == 2">
                                                {{ bytesToSize(item.FileSize) }}
                                            </span>
                                        </td>
                                        <td style="width: 22%;" class="btns">
                                            <button v-if="item.FileType == 0" class="iconfont icon-xiazai1" title="下载" @click.stop="download(item)"></button>
                                            <button class="iconfont iconicon_yulan" title="预览" @click.stop="viewFileClick(item)"></button>
                                        </td>
                                        <td style="width: 21%;" :title="item.describe">
                                            {{ item.FileDescription }}
                                        </td>
                                        <td>{{ item.CreateDate }}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr class="noeAnnexData">
                                        <td colspan="6">
                                            <p></p>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '@/styles/components/formAnnex/annexStyle.styl';
export default {
    // 流程附件
    name: 'annex-data',
    components: {},
    props: {
        businessInstanceId: {
            type: [Array, Object, String ],
        },
        extr: {
            type: [Object],
        },
        platformEnterprises: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            // 租户id
            zu_h_id: '',
            allAccessoriesData: [],
            // 面包屑导航数据
            fileHierarchy: [],
            // 附件数据集合
            fileData: [],
            // 预览图片ID集合
            picturePreview: [],
            // 当前父ID 新增文件夹使用
            ParentID: 0,
            // 当前父ID 上传附件使用，在文件夹上上传，和新增文件父id不一样
            currentFile: '',
            // 当前父ID 新增文件夹使用
            ParentID2: '',
            // 当前父ID 上传附件使用，在文件夹上上传，和新增文件父id不一样
            currentFile2: '',
            // 上传文件加载中状态
            loading: false,
            // 当前用户id
            Uid: this.$takeTokenParameters('Uid'),
        };
    },
    created() {
        if (this.extr?.zu_h_id) {
            this.zu_h_id = this.extr.zu_h_id;
        }
        this.gitAnnexData(this.businessInstanceId);
        if (this.zu_h_id) {
            this.gitAccountData();
        }
    },
    watch: {},
    methods: {
        // 获取附件数据
        gitAnnexData(businessInstanceId) {
            this.loading = true;
            const url = `tenant_id=${this.zu_h_id}&platformEnterprises=${this.platformEnterprises}`;
            this.$axios
                .get(`/interfaceApi/basicplatform/simpleflow/filegroupinstance/${businessInstanceId}?${url}`)
                .then(res => {
                    this.allAccessoriesData = JSON.parse(JSON.stringify([...res, ...this.allAccessoriesData]));
                    this.fileData = this.initFileData(this.allAccessoriesData, { val1: this.currentFile, val2: this.currentFile2 });
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 获取对账单附件数据
        gitAccountData() {
            this.loading = true;
            const url = `contract_number=${this.extr.contract_number}&tenant_id=${this.zu_h_id}&platformEnterprises=${this.platformEnterprises}`;
            this.$axios
                .get(`/interfaceApi/sale/contract_manager/get_statement_file/by_contract_number?${url}`)
                .then(res => {
                    const arr = [];
                    res.forEach(item => {
                        arr.push({
                            AFI_Code: item.id,
                            FileName: item.name,
                            FileID: item.id,
                            FileType: item.data_type + '',
                            ParentID: item.data_type === 1 ? '0' : item.parent_id,
                            FileSize: item.size,
                            FileExt: item.ext,
                            ...item,
                        });
                    });
                    this.allAccessoriesData = JSON.parse(JSON.stringify([...this.allAccessoriesData, ...arr]));
                    this.fileData = this.initFileData(this.allAccessoriesData, { val1: this.currentFile, val2: this.currentFile2 });
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$message.error(error.ErrorCode.Message);
                });
        },

        // 文件大小转换
        bytesToSize(fileByte) {
            const fileSizeByte = fileByte;
            let fileSizeMsg = '';
            if (fileSizeByte < 1048576) {
                fileSizeMsg = (fileSizeByte / 1024).toFixed(1) + 'KB';
            } else if (fileSizeByte === 1048576) {
                fileSizeMsg = '1MB';
            } else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) {
                fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(1) + 'MB';
            } else if (fileSizeByte > 1048576 && fileSizeByte === 1073741824) {
                fileSizeMsg = '1GB';
            } else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) {
                fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(1) + 'GB';
            } else {
                fileSizeMsg = '文件超过1TB';
            }
            return fileSizeMsg;
        },
        // 根据id过滤附件数据
        initFileData(newVal, val, type) {
            const initFileData = [];
            if (newVal && newVal !== null) {
                newVal.forEach(item => {
                    if (item.ParentID === val.val1 || item.ParentID === val.val2) {
                        if (type === 'FileID' && item.FileType !== '1') {
                            initFileData.push(item.FileID);
                        } else {
                            initFileData.push(item);
                        }
                    }
                });
            }
            return initFileData;
        },
        // 文件下载
        download(data) {
            const downloadUrl = `${this.FILE.FILE_BASE_URL()}file-manage/${data.AFI_Code}/download?platformEnterprises=${this.platformEnterprises}`;
            this.$imagesDownload(downloadUrl, data.FileName);
        },
        // 批量下载
        batchDownload() {
            this.allAccessoriesData.forEach(async item => {
                if (item.FileType === '0') {
                    const downloadUrl = `${this.FILE.FILE_BASE_URL()}file-manage/${item.AFI_Code}/download?platformEnterprises=${this.platformEnterprises}`;
                    await this.$imagesDownload(downloadUrl, item.FileName);
                }
            });
        },
        //   预览
        viewFileClick(data) {
            this.picturePreview = [];
            if (data.FileType === '0') {
                this.picturePreview.push(data.AFI_Code);
            } else if (data.FileType === '1' && data.AFI_Code) {
                this.picturePreview = this.initFileData(this.allAccessoriesData, { val1: data.AFI_Code, val2: data.AFI_Code }, 'FileID');
            }
            if (this.picturePreview.length > 0) {
                this.$toast({
                    title: true,
                    text: '预览',
                    type: 'eject',
                    width: '80%',
                    height: '88%',
                    t_url: 'picturePreview/index',
                    extr: {
                        code: {
                            imgSrc: [],
                            picturePreview: this.picturePreview,
                            platformEnterprises: this.platformEnterprises,
                        },
                    },
                    viewPosition: 'components',
                });
            }
        },
        // 查看
        seeFile(data) {
            if (data.FileType !== 0 && data.FileType !== '0') {
                this.ParentID = data.FileID;
                this.currentFile = data.FileID;
                const newFileData = [];
                if (this.allAccessoriesData && this.allAccessoriesData !== null) {
                    this.allAccessoriesData.forEach(item => {
                        if (item.ParentID === data.FileID) {
                            newFileData.push(item);
                        }
                    });
                }
                this.fileData = newFileData;
                this.fileHierarchy.push(
                    {
                        data: data.FileName,
                        id: data.FileID,
                    }
                );
            }
        },
        // 返回顶层
        backTop() {
            this.fileData = this.initFileData(this.allAccessoriesData, { val1: '', val2: '' });
            this.ParentID = '';
            this.currentFile = '';
            this.ParentID2 = '';
            this.currentFile2 = '';
            this.fileHierarchy = [];
        },
        // 返回上级目录
        returnDirectory(id, index) {
            this.fileData = this.initFileData(this.allAccessoriesData, { val1: id, val2: id });
            this.fileHierarchy.splice(index + 1, this.fileHierarchy.length - index);
        },
    },
};
</script>

<style lang="stylus" scoped>
#annexData
    padding 0.073rem
</style>
